import { globalHistory } from "@gatsbyjs/reach-router";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Link as ScrollLink } from "react-scroll";
import { dropdownData, subDropdownData } from "../../utils/data";
import { redirectLinks } from "../../utils/redirect-links";
import Dropdown from "../Dropdown";
import Logo from "../Logo";
import MobileMenu from "../MobileMenu";
import * as S from "./styles";

const NavBar = ({ switchButton }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [checked, setChecked] = useState(false);
  const [pathname, setPathname] = useState(
    typeof window !== "undefined" ? window.location.pathname : "/"
  );
  const isPage = pathname.length > 1;

  const toggleMenu = () => setChecked(!checked);

  useEffect(
    () => globalHistory.listen(({ location }) => setPathname(location.pathname)),
    []
  );

  return (
    <S.Navbar>
      <Logo />
      <MobileMenu checked={checked} toggleMenu={toggleMenu} />

      <S.NavbarCollapse visible={checked}>
        <S.NavbarList>
          {isPage ? (
            <React.Fragment>
              {redirectLinks.map((link, index) => (
                <S.NavbarItem key={index}>
                  <Link to="/" state={{ scrollTo: link.anchor }}>
                    {link.text}
                  </Link>
                </S.NavbarItem>
              ))}
            </React.Fragment>
          ) : (
            redirectLinks.map((link, index) => (
              <S.NavbarItem key={index}>
                <ScrollLink
                  activeClass="active"
                  spy={true}
                  to={link.anchor}
                  offset={isDesktop ? -250 : -280}
                >
                  {link.text}
                </ScrollLink>
              </S.NavbarItem>
            ))
          )}

          <Dropdown
            title="Especialidades"
            dropdownItems={dropdownData}
            subDropdownItems={subDropdownData}
          />

          {isDesktop && switchButton}
        </S.NavbarList>

        {!isDesktop && switchButton}
      </S.NavbarCollapse>
    </S.Navbar>
  );
};

NavBar.propTypes = {
  switchButton: PropTypes.element.isRequired,
};

export default NavBar;
